module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-558f95d8a283cdbadbed219eaa005ac8.png";